import { isArray, isString } from '@shared/utils/assertions';
import qs from 'query-string';

export const FILTER_QS_PARSE_OPTIONS: qs.ParseOptions = { arrayFormat: 'separator', arrayFormatSeparator: '|' };

const deriveCompositeCode = (groupCode: string, valueCode: string) => `${groupCode}:${valueCode}`;

export const deriveActiveFiltersFromUrl = (url: string): Set<string> => {
  const { query } = qs.parseUrl(url, FILTER_QS_PARSE_OPTIONS);
  const productFiltersParam = query.pf;

  if (typeof productFiltersParam != 'string') return new Set();

  const productFilters = qs.parse(productFiltersParam, FILTER_QS_PARSE_OPTIONS);
  const codes = new Set<string>();
  Object.keys(productFilters).forEach(groupCode => {
    const attributeValue = productFilters[groupCode];
    if (isArray(attributeValue)) {
      attributeValue.forEach(valueCode => {
        codes.add(deriveCompositeCode(groupCode, valueCode));
      });
    } else if (isString(attributeValue)) {
      codes.add(deriveCompositeCode(groupCode, attributeValue));
    }
  });
  return codes;
};
